export const PATH_HOME = "/home";
export const PATH_CONTACT = "/contact";
export const PATH_SERVICE = "/service";
export const PATH_ABOUT = "/about";
export const PATH_PORTFOLIO = "/portfolio";
export const PATH_HOME_SECTION = "/home_section";
export const PATH_ABOUT_SECTION = "/about_section";
export const PATH_SERVICES_SECTION = "/services_section";
export const PATH_CONTACT_SECTION = "/contact_section";
export const PATH_CONTACT_FORM = "/contact_form";
export const PATH_PORTFOLIO_SECTION = "/portfolio_section";
export const PATH_TECHNOLOGY = "/technology";
export const PATH_SERVICE_DETAIL = "/service_detail";

//Key Token
export const KEY_USER_TOKEN = "token";
